class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    document.addEventListener("cartdrawer:refresh", function (e) {
      this.doRefresh();
    }.bind(this));
  }

  doRefresh() {
    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      sections: sections,
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        this.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
          this.registerCartAttributesListener();
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  registerCartAttributesListener() {

    const deliverySelect = document.getElementById('delivery_pref');

    function updateAttribute(selectedValue) {
      let formData = {
        'attributes': {
          'delivery-preference': selectedValue,
        }
      };

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          console.log(response.json());
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    deliverySelect.addEventListener('change', function () {
      const selectedValue = this.value;
      updateAttribute(selectedValue);
    });

    updateAttribute("door-delivery");

  }
  
}

customElements.define('mini-cart', MiniCart);

